import { PageTitle } from "@/components/ui/PageTitle";

export const SecurityHeader = () => {
  return (
    <PageTitle
      title="Sécurité"
      subtitle="Gérez les paramètres de sécurité de votre compte"
    />
  );
};